import { useState } from 'react';
import { motion } from 'framer-motion';

export const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section id="contact" className="py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12 text-cyan-400 neon-text">
          Let AI Work for You
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">
              &gt; Name:
            </label>
            <input
              type="text"
              className="w-full bg-black border-2 border-cyan-500/30 rounded p-3 text-white focus:border-cyan-400 focus:outline-none"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">
              &gt; Business Email:
            </label>
            <input
              type="email"
              className="w-full bg-black border-2 border-cyan-500/30 rounded p-3 text-white focus:border-cyan-400 focus:outline-none"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">
              &gt; Industry:
            </label>
            <select
              className="w-full bg-black border-2 border-cyan-500/30 rounded p-3 text-white focus:border-cyan-400 focus:outline-none"
              required
            >
              <option value="">Select your industry</option>
              <option value="ecommerce">E-commerce</option>
              <option value="saas">SaaS</option>
              <option value="healthcare">Healthcare</option>
              <option value="finance">Finance</option>
              <option value="real-estate">Real Estate</option>
              <option value="education">Education</option>
              <option value="other">Other</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">
              &gt; AI Service Interest:
            </label>
            <select
              className="w-full bg-black border-2 border-cyan-500/30 rounded p-3 text-white focus:border-cyan-400 focus:outline-none"
              required
            >
              <option value="">Select service</option>
              <option value="chatbot">Customer Support Chatbot</option>
              <option value="whatsapp">WhatsApp AI Integration</option>
              <option value="website">AI Website Development</option>
              <option value="email">Email Automation</option>
              <option value="voice">AI Voice Callers</option>
              <option value="leads">Automated Lead Generation</option>
              <option value="appointments">AI Appointment Setters</option>
              <option value="integration">Integration Hub</option>
            </select>
          </div>
          
          <button
            type="submit"
            className="cta-button w-full rounded text-lg font-semibold"
          >
            &gt; Automate My Business Now
          </button>
        </form>
        
        {submitted && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-4 text-center text-green-400"
          >
            &gt; Thank you! Scheduling your free AI consultation...
          </motion.div>
        )}
      </div>
    </section>
  );
};